import React, {FunctionComponent} from 'react';
import { getShopInfosInStorage } from './ShopInfos';
import { TranslationProps, WithTranslation } from '../../contexts/TranslationContext';


const RenderLegendCartFC: FunctionComponent<TranslationProps> = ({textsContent}): JSX.Element => {
  const shopInfos = getShopInfosInStorage();
  
  /**
  * Ne s'affiche que pour TO et TE
  */
  const renderMarquage = () => {
    if (shopInfos.Ref === 'TE' || shopInfos.Ref === 'TO' || shopInfos.Ref === 'TH') {
      return (
        <div className="col-xl-2 col-lg-2 text-center d-none d-lg-block">
          <span className="mx-auto">Marquage</span>
        </div>
      );
    }
  };

  let col2 = 'col-lg-1 col-xl-1';
  let col3 = 'col-lg-2 col-xl-2';
  if (shopInfos.Ref  == 'MT' || shopInfos.Ref  == 'ME') {
    col2 = 'col-lg-2 col-xl-2';
    col3 = 'col-lg-3 col-xl-3';
  }

  return (
    <div className="d-none d-lg-flex align-items-center p-2" id="legendCartItemTemplate">
      <div className="col-lg-4 col-xl-4 text-left">
        <div className="w-100">{textsContent?.['CART_TABLE_HEADER_DESCRIPTION']}</div>
      </div>
      {renderMarquage()}
      {(shopInfos.Ref != 'DT') &&
      <div className={col2 + ' text-center'}>
        <div className="w-100">{textsContent?.['CART_TABLE_HEADER_AVAILABILITY']}</div>
      </div>
      }
      <div className={(shopInfos.Ref  == 'DG' || shopInfos.Ref  == 'DT') ? col3 + ' flex-grow-1 text-right' : col3 + ' flex-grow-1 text-center'}>
        <div className="w-100">{textsContent?.['CART_TABLE_HEADER_PU']}</div>
      </div>
      <div className={shopInfos.Ref  == 'DT' ? 'col-lg-4 col-xl-4  text-center' : 'col-lg-1 col-xl-1  text-center'}>
        <div className="w-100">{textsContent?.['CART_TABLE_HEADER_QUANTITY']}</div>
      </div>
      <div className={'col-lg-2 col-xl-2 text-right'}>
        <div className="w-100 pr29">{textsContent?.['CART_TABLE_HEADER_TOTAL_HT']}</div>
      </div>
    </div>
  );
};

export const RenderLegendCart = WithTranslation(RenderLegendCartFC, 'CART_TUNNEL');
